/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Mithun's Portfolio",
  description:
    "👋 My name is Mithun G. I'm a student at Jain University. I'm a cricket analyst and data science enthusiast",
  og: {
    title: "Mithun G Portfolio",
    type: "website",
    url: "https://mithun162001.github.io/Portfolio/",
  },
};

//Home Page
const greeting = {
  title: "Mithun G",
  logo_name: "Mithun",
  nickname: "Deadbeef",
  subTitle:
    "👋 My name is Mithun G. I'm a student at Jain University. I'm a cricket analyst and data science enthusiast",
  //resumeLink:
  //  "https://drive.google.com/open?id=1XYpYhLeqCdyx_q6l0bQoC7RgwQjAjXPf",
  portfolio_repository: "https://github.com/Mithun162001/New-site",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/Mithun162001",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/mithun-g-b64163191/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:mithun162001@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/cricmithu16/",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/profile.php?id=100012792757258",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/mithun162001/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & ML",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Currently learning Machine Learning Algorithms",
        "⚡ Has implemented some basic ML models which I learnt recently",
        "⚡ Current focus is to study Neural Networks and Deep Learning",
      ],
      softwareSkills: [
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "numpy",
          fontAwesomeClassname: "simple-icons:numpy",

          style: {
            backgroundColor: "transparent",
            color: "#D00000",
          },
        },
        {
          skillName: "Scikit Learn",
          fontAwesomeClassname: "simple-icons:scikit-learn",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    {
      title: "Cricket Analyst",
      fileName: "DesignImg",
      skills: [
        "⚡ Writes cricket based articles in some cricket sites",
        "⚡ Analyze the game of cricket and share my thoughts in my twitter",
      
      ],
      softwareSkills: [
        {
          skillName: "Cricket Analysis",
          fontAwesomeClassname: "emojione-cricket-game",
          style: {
            color: "#FF2BC2",
          },
        },
        
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/mithun162001/competitions",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "School of Engineering and technology, Jain University",
      subtitle: "B.Tech. Computer Science honors in Data Science",
      logo_path: "jainlogo.png",
      alt_name: "Jain University",
      duration: "2019 - Present",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, PSP etc.",
        "⚡ Apart from this, I have done courses on Python, Data Analysis, Machine Learning, Data Visualisation.",
      ],
      website_link: "https://www.jainuniversity.ac.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Python Crash Course",
      subtitle: "- Google",
      logo_path: "google_logo.png",
      certificate_link:
        "https://github.com/Mithun162001/Certificates/blob/main/Google%20Crash%20Course%20Certificate.pdf",
      alt_name: "Google Career Certificate ",
      color_code: "#11111111",
    },
    {
      title: "Python for Data Science Essential Training Part:1",
      subtitle: "- Lillian Pierson, P.E",
      logo_path: "linkedin.png",
      certificate_link:
        "https://github.com/Mithun162001/Certificates/blob/main/CertificateOfCompletion_Python%20for%20Data%20Science%20Essential%20Training%20Part%201.pdf",
      alt_name: "Linkedin Learning",
      color_code: "#00000099",
    },

    {
      title: "National Association of State Boards of Accountancy",
      subtitle: "- Statistics Foundations",
      logo_path: "linkedin.png",
      certificate_link:
        "https://github.com/Mithun162001/Certificates/blob/main/National%20Association%20of%20State%20Boards%20of%20Accountancy%20(NASBA).pdf",
      alt_name: "Linkedin Learning",
      color_code: "#00000099",
    },

    {
      title: "Kaggle - Python",
      subtitle: "- Colin Morris",
      logo_path: "kaggle.png",
      certificate_link:
        "https://github.com/Mithun162001/Certificates/blob/main/Kaggle%20Python%20Certficate.png",
      alt_name: "Kaggle Micro Course",
      color_code: "#00000001",

    },
    {
      title: "Kaggle - Pandas",
      subtitle: "- Aleksey Bilogur",
      logo_path: "kaggle.png",
      certificate_link:
        "https://github.com/Mithun162001/Certificates/blob/main/Kaggle%20Pandas%20Certficate.png",
      alt_name: "Kaggle Micro Course",
      color_code: "#00000001",
    },
    {
      title: "Kaggle - Data Visualization",
      subtitle: "- Alexis Cook",
      logo_path: "kaggle.png",
      certificate_link:
        "https://github.com/Mithun162001/Certificates/blob/main/Mithun%20G%20-%20Data%20Visualization.png",
      alt_name: "Kaggle Micro Course",
      color_code: "#00000001",
    },
    {
      title: "Kaggle - Intro to Machine Learning",
      subtitle: "- Dan Becker",
      logo_path: "kaggle.png",
      certificate_link:
        "https://github.com/Mithun162001/Certificates/blob/main/Kaggle%20-%20Intro%20to%20Machine%20Learning.png",
      alt_name: "Kaggle Micro Course",
      color_code: "#00000001",
    },
   
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Student",
  description:
    "Im still a 2nd year engineering student",
  header_image_path: "experience.svg",
  sections: [
    
    {
      title: "Internships",
      experiences: [
       
        
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/Mithun162001",
          logo_path: "github_logo.png",
          duration: "April 2021 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to a open source repository of Python Notebooks which shares the notebook files of basic Data Science practiions like Data Handling, Data Visualization, Data Analysis, Numpy library and Machine Learning Algorithms.",
          color: "#181717",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects are basically of Machine Learning applications like Classification probelms, Regression problems and Clustering",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Profile.jpeg",
    description:
      "I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, DS, Python, Java",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I write articles on cricket analysis and you can follow by blogsplot in the mentioned link",
    link: "https://t.co/7ozeBXPDab?amp=1",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "9, 1st 'F' Cross, 8th Main, Lakshmannagar, Sunkadakatte, Bengaluru - 560 091",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/pQeUwcKFpNKcGSjg9",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+91 8431079816",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
};
